<template>
  <div id="adminDashboard">
    <section id="top">
      <div class="container">
        <div class="row">
          <h1 class="col-sm-4">회원사 현황</h1>
          <div class="col-sm-8 toolbar">
            <label>기간설정</label>
            <div class="date-range-picker-wrap">
              <date-range-picker
                ref="picker"
                :class="{'active': isActivePicker}"
                :auto-apply="dateRangeOptions.openApply"
                :showDropdowns="dateRangeOptions.showDropdowns"
                :locale-data="dateRangeOptions.locale"
                :ranges="dateRangeOptions.ranges"
                :min-date="dateRangeOptions.minDate"
                :max-date="dateRangeOptions.maxDate"
                @toggle="bool => isActivePicker = bool"
                @update="convertDate"
                v-model="dateRange"
              >
              </date-range-picker>
            </div>
            <button type="button" class="hz-btn-default hz-btn-lg disabled" @click="search">검색</button>
          </div>
        </div>
        <div class="row">
          <h4 class="p-l-8 m-b-8">이용자 현황 <small>{{ cumulativeCompanyText }}</small></h4>
          <div class="col-lg-3 col-md-6">
            <div class="card" @click="toPartner">
              <div class="row">
                <div class="col-xs-5">
                  <p class="type">전체 회원사</p>
                </div>
                <div class="col-xs-7">
                  <p v-if="dataStatus.usageStatus === 'success'" class="count">{{ usageStatusData.total }} <small>개</small></p>
                  <p v-else class="count">- <small>개</small></p>
                  <p class="count diff" :class="[prevUsageStatusData.total <= usageStatusData.total ? 'color-red' : 'color-blue']">{{ diffUsageStatusDataTotal }}</p>
                  <span class="ic-arrow-right"></span>
                </div>
              </div>
            </div>

          </div>
          <div class="col-lg-3 col-md-6">
            <div class="card" @click="toPartner">
              <div class="row">
                <div class="col-xs-5">
                  <p class="type">사용 회원사</p>
                </div>
                <div class="col-xs-7">
                  <p v-if="dataStatus.usageStatus === 'success'" class="count">{{ usageStatusData.active }} <small>개</small></p>
                  <p v-else class="count">- <small>개</small></p>
                  <p class="count diff" :class="[prevUsageStatusData.active <= usageStatusData.active ? 'color-red' : 'color-blue']">{{ diffUsageStatusDataActive }}</p>
                  <span class="ic-arrow-right"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="card" @click="toPartner">
              <div class="row">
                <div class="col-xs-5">
                  <p class="type">신규 가입자</p>
                </div>
                <div class="col-xs-7">
                  <p v-if="dataStatus.usageStatus === 'success'" class="count">{{ usageStatusData.new }} <small>개</small></p>
                  <p v-else class="count">- <small>개</small></p>
                  <p class="count diff" :class="[prevUsageStatusData.new <= usageStatusData.new ? 'color-red' : 'color-blue']">{{ diffUsageStatusDataNew }}</p>
                  <span class="ic-arrow-right"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="card" @click="toGoogleAnalytics">
              <div class="row">
                <div class="col-xs-5">
                  <p class="type">GA 사용자</p>
                </div>
                <div class="col-xs-7">
                  <p v-if="dataStatus.usageStatus === 'success'" class="count">{{ usageStatusData.ga_users }} <small>명</small></p>
                  <p v-else class="count">- <small>개</small></p>
                  <p class="count diff" :class="[prevUsageStatusData.ga_users <= usageStatusData.ga_users ? 'color-red' : 'color-blue']">{{ diffUsageStatusDataGaUsers }}</p>
                  <span class="ic-arrow-right"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div class="card card-usage-status">
              <div class="row card-header">
                <div class="col-sm-6">
                  <h4>현황 그래프 <button class="btn-csv-download" @click="clickCSV">CSV</button></h4>
                </div>
                <div class="col-sm-6 text-right">
                  <div class="radio-btn-group">
                    <div class="radio-btn-group-item">
                      <input type="radio" id="day" name="day" value="day" v-model="pickedDateType">
                      <label for="day">일</label>
                    </div>
                    <div class="radio-btn-group-item">
                      <input type="radio" id="week" name="week" value="week" v-model="pickedDateType">
                      <label for="week">주</label>
                    </div>
                    <div class="radio-btn-group-item">
                      <input type="radio" id="month" name="month" value="month" v-model="pickedDateType">
                      <label for="month">월</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <usage-status-chart
                  v-if="dataStatus.usageStatusChart === 'success'"
                  :dateType="pickedDateType"
                  :chartData="usageStatusChartData"
                >
                </usage-status-chart>
                <p class="error-txt" v-else-if="dataStatus.usageStatusChart === 'error'">데이터 불러오기를 실패했습니다.</p>
                <bar-loader class="bar-loader" v-else></bar-loader>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card card-inflow-path">
              <div class="card-header">
                <h4>유입경로 비율</h4>
              </div>
              <div class="card-body">
                <inflow-path-chart
                  v-if="dataStatus.inflowPathChart === 'success'"
                  :chartData="inflowPathChartData"
                >
                </inflow-path-chart>
                <p class="error-txt" v-else-if="dataStatus.inflowPathChart === 'error'">데이터 불러오기를 실패했습니다.</p>
                <bar-loader class="bar-loader" v-else></bar-loader>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="card card-application-status">
              <div class="row card-header margin-bottom-16">
                <h4>신청현황</h4>
              </div>
              <div class="card-body">
                <application-status-chart
                  v-if="dataStatus.applicationStatusChart === 'success'"
                  :dateType="pickedDateType"
                  :chartData="applicationStatusChartData"
                >
                </application-status-chart>
                <p class="error-txt" v-else-if="dataStatus.applicationStatusChart === 'error'">데이터 불러오기를 실패했습니다.</p>
                <bar-loader class="bar-loader" v-else></bar-loader>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card card-application-table">
              <table v-if="dataStatus.applicationStatusTable === 'success'">
                <thead>
                <tr>
                  <th>서비스명</th>
                  <th>전체</th>
                  <th>신규</th>
                  <th>진행</th>
                  <th>완료</th>
                </tr>
                </thead>
                <tbody>
                <tr @click="scrollToReportTable">
                  <td style="color: #278A96;"><span class="circle" style="background-color: #278A96;"></span> 검토</td>
                  <td>{{ applicationStatusTableData.oneclick_search.total }}</td>
                  <td>{{ applicationStatusTableData.oneclick_search.new }}</td>
                  <td>{{ applicationStatusTableData.oneclick_search.ing }}</td>
                  <td>{{ applicationStatusTableData.oneclick_search.done }}</td>
                </tr>
                <tr @click="scrollToReportTable">
                  <td style="color: #365ac0;"><span class="circle" style="background-color: #365ac0;"></span> 원클릭</td>
                  <td>{{ applicationStatusTableData.oneclick.total }}</td>
                  <td>{{ applicationStatusTableData.oneclick.new }}</td>
                  <td>{{ applicationStatusTableData.oneclick.ing }}</td>
                  <td>{{ applicationStatusTableData.oneclick.done }}</td>
                </tr>
                <tr @click="scrollToReportTable">
                  <td style="color: #9b88e9;"><span class="circle" style="background-color: #9b88e9;"></span> 프리미엄</td>
                  <td>{{ applicationStatusTableData.premium.total }}</td>
                  <td>{{ applicationStatusTableData.premium.new }}</td>
                  <td>{{ applicationStatusTableData.premium.ing }}</td>
                  <td>{{ applicationStatusTableData.premium.done }}</td>
                </tr>
                <tr @click="toAdminHaezoom({path: '/biz', query: { category: 'shop_application', status: '' }}, $event)">
                  <td style="color: #8ebafb;">
                    <span class="circle" style="background-color: #8ebafb;"></span> 제품구매
                  </td>
                  <td>{{ applicationStatusTableData.shop.total }}</td>
                  <td data-status="new">{{ applicationStatusTableData.shop.new }}</td>
                  <td data-status="ing">{{ applicationStatusTableData.shop.ing }}</td>
                  <td data-status="done">{{ applicationStatusTableData.shop.done }}</td>
                </tr>
                <tr @click="toAdminHaezoom({path: '/biz', query: { category: 'report_insurance', status: '' }}, $event)">
                  <td style="color: #ffd43b;"><span class="circle" style="background-color: #ffd43b;"></span> 보험대행</td>
                  <td>{{ applicationStatusTableData.insurance.total }}</td>
                  <td data-status="new">{{ applicationStatusTableData.insurance.new }}</td>
                  <td data-status="ing">{{ applicationStatusTableData.insurance.ing }}</td>
                  <td data-status="done">{{ applicationStatusTableData.insurance.done }}</td>
                </tr>
                <tr @click="toAdminHaezoom({path: '/biz/bizcare', query: { step: '' }}, $event)">
                  <td style="color: #ff6b6b;"><span class="circle" style="background-color: #ff6b6b;"></span> 비즈케어</td>
                  <td>{{ applicationStatusTableData.bizcare.total }}</td>
                  <td data-step="신규">{{ applicationStatusTableData.bizcare.new }}</td>
                  <td data-step="진행">{{ applicationStatusTableData.bizcare.ing }}</td>
                  <td data-step="완료">{{ applicationStatusTableData.bizcare.done }}</td>
                </tr>
                <tr @click="toAdminHaezoom({path: '/services/vpp/partner', query: { step: '' }}, $event)">
                  <td style="color: #40678f;"><span class="circle" style="background-color: #40678f;"></span> 전력중개사업</td>
                  <td>{{ applicationStatusTableData.vpp.total }}</td>
                  <td data-step="신규">{{ applicationStatusTableData.vpp.new }}</td>
                  <td data-step="진행">{{ applicationStatusTableData.vpp.ing }}</td>
                  <td data-step="완료">{{ applicationStatusTableData.vpp.done }}</td>
                </tr>
                <tr @click="toAdminHaezoom({path: '/biz', query: { category: 'bizcscenter_inquery', status: '' }}, $event)">
                  <td style="color: #00c4ad;"><span class="circle" style="background-color: #00c4ad;"></span> 제휴/문의</td>
                  <td>{{ applicationStatusTableData.inquery.total }}</td>
                  <td data-status="new">{{ applicationStatusTableData.inquery.new }}</td>
                  <td data-status="ing">{{ applicationStatusTableData.inquery.ing }}</td>
                  <td data-status="done">{{ applicationStatusTableData.inquery.done }}</td>
                </tr>
                <tr @click="$router.push({name: 'useCoupon'})">
                  <td style="color: #ff7133;"><span class="circle" style="background-color: #ff7133;"></span> 이용권</td>
                  <td>{{ applicationStatusTableData.paid.total }}</td>
                  <td>{{ applicationStatusTableData.paid.new }}</td>
                  <td>{{ applicationStatusTableData.paid.ing }}</td>
                  <td>{{ applicationStatusTableData.paid.done }}</td>
                </tr>
                </tbody>
              </table>
              <p class="error-txt" v-else-if="dataStatus.applicationStatusTable === 'error'">데이터 불러오기를 실패했습니다.</p>
              <bar-loader class="bar-loader" v-else></bar-loader>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="card card-report-table">
              <div class="card-header margin-bottom-16">
                <h4>보고서 이용현황</h4>
              </div>
              <table v-if="dataStatus.reportUsageTable === 'success'">
                <thead>
                  <tr>
                    <th style="width: 33%;">회원사명</th>
                    <th>전체</th>
                    <th>검토</th>
                    <th>원클릭</th>
                    <th>프리미엄</th>
                  </tr>
                </thead>
                <tbody v-if="reportUsageTableData.length > 0">
                  <tr v-for="report in reportUsageTableData"
                      :key="report.id"
                      @click="toAdminHaezoom({path: `/biz/partner/detail/?id=${report.id}`}, $event)">
                    <td style="width: 33%;" :title="report.name">
                      {{ report.name }}
                    </td>
                    <td>{{ report.total }}</td>
                    <td>{{ report.oneclick_search }}</td>
                    <td>{{ report.oneclick_save }}</td>
                    <td>{{ report.premium_save }}</td>
                  </tr>
                </tbody>
                <tbody v-else style="text-align: center; line-height: 311px;">
                  이용 내역이 없습니다.
                </tbody>
              </table>
              <p class="error-txt" v-else-if="dataStatus.reportUsageTable === 'error'">데이터 불러오기를 실패했습니다.</p>
              <bar-loader class="bar-loader" v-else></bar-loader>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 알림창 -->
    <modal ref="notifyModal"
           :id="notifyModal.id"
           :type="notifyModal.type"
           :title="notifyModal.title"
           :size="notifyModal.size"
           :fields="notifyModal.fields"></modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import UsageStatusChart from '@/components/admin/UsageStatusChart'
  import InflowPathChart from '@/components/admin/InflowPathChart'
  import ApplicationStatusChart from '@/components/admin/ApplicationStatusChart'
  import BarLoader from 'common/components/BarLoader'
  import Modal from 'common/components/Modal'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

  export default {
    name: 'admin-dashboard',
    components: {
      BarLoader,
      DateRangePicker,
      UsageStatusChart,
      InflowPathChart,
      ApplicationStatusChart,
      Modal
    },
    data () {
      return {
        dataUrl: location.protocol + '//' + location.hostname.replace('biz', 'api'),
        isActivePicker: false,
        dateRange: {
          startDate: null,
          endDate: null
        },
        dateRangeOptions: {
          minDate: null,
          maxDate: null,
          openApply: true,
          showDropdowns: true,
          locale: {
            direction: 'ltr',
            format: 'yyyy.mm.dd',
            separator: ' ~ ',
            applyLabel: '적용',
            cancelLabel: '취소',
            weekLabel: 'W',
            daysOfWeek: ['일', '월', '화', '수', '목', '금', '토'],
            monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            firstDay: 0
          },
          ranges: false
        },
        dataStatus: {
          usageStatus: '',
          prevUsageStatus: '',
          usageStatusChart: '',
          inflowPathChart: '',
          applicationStatusChart: '',
          applicationStatusTable: '',
          reportUsageTable: ''
        },
        pickedDateType: 'day',
        usageStatusData: {
          cumulative: 0,
          total: 0,
          active: 0,
          new: 0,
          ga_users: 0
        },
        prevUsageStatusData: {
          total: 0,
          active: 0,
          new: 0,
          ga_users: 0
        },
        usageStatusChartData: {
          day: [],
          week: [],
          month: []
        },
        inflowPathChartData: [],
        applicationStatusChartData: {},
        applicationStatusTableData: {},
        reportUsageTableData: [],
        notifyModal: {
          id: 'notifyModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['데이터 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.'],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      cumulativeCompanyText () {
        const companyCnt = this.usageStatusData.cumulative
        const nowDate = moment().format('YYYY.MM.DD')
        return `누적 전체 회원사 ${companyCnt}개 (${nowDate} 기준)`
      },
      // 이용자현황, 전체회원사, 이전 기간과 비교
      diffUsageStatusDataTotal () {
        if (this.dataStatus.usageStatus === 'success' && this.dataStatus.prevUsageStatus === 'success') {
          return this.getUsageStatusDiffString(this.prevUsageStatusData.total, this.usageStatusData.total)
        } else {
          return ''
        }
      },
      // 이용자현황, 사용 회원사, 이전 기간과 비교
      diffUsageStatusDataActive () {
        if (this.dataStatus.usageStatus === 'success' && this.dataStatus.prevUsageStatus === 'success') {
          return this.getUsageStatusDiffString(this.prevUsageStatusData.active, this.usageStatusData.active)
        } else {
          return ''
        }
      },
      // 이용자현황, 신규 가입자, 이전 기간과 비교
      diffUsageStatusDataNew () {
        if (this.dataStatus.usageStatus === 'success' && this.dataStatus.prevUsageStatus === 'success') {
          return this.getUsageStatusDiffString(this.prevUsageStatusData.new, this.usageStatusData.new)
        } else {
          return ''
        }
      },
      // 이용자현황, GA 사용자, 이전 기간과 비교
      diffUsageStatusDataGaUsers () {
        if (this.dataStatus.usageStatus === 'success' && this.dataStatus.prevUsageStatus === 'success') {
          return this.getUsageStatusDiffString(this.prevUsageStatusData.ga_users, this.usageStatusData.ga_users)
        } else {
          return ''
        }
      }
    },
    methods: {
      clickCSV () {
        const { startDate, endDate } = this.dateRange
        const token = localStorage.getItem('_t')
        window.open(`${this.dataUrl}/biz/dashboard/user/csv/${this.pickedDateType}/?start_date=${startDate}&end_date=${endDate}&token=${token}`)
      },
      convertDate () {
        this.dateRange = {
          startDate: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.dateRange.endDate).format('YYYY-MM-DD')
        }
      },
      search () {
        const isLoad = _.findKey(this.dataStatus, (status) => { return status === 'load' })

        if (isLoad) {
          this.$refs.notifyModal.show()
          return
        }

        this.getUsageStatusData()
        this.getUsageStatusChartData()
        this.getInflowPathChartData()
        this.getApplicationStatusChartData()
        this.getApplicationStatusTableData()
        this.getReportUsageData()
      },
      getUsageStatusData () {
        const { startDate, endDate } = this.dateRange

        this.dataStatus.usageStatus = 'load'
        axios.get(`biz/dashboard/user/?start_date=${startDate}&end_date=${endDate}`)
          .then(response => {
            this.usageStatusData = response.data
            this.dataStatus.usageStatus = 'success'
          })
          .catch(e => {
            this.dataStatus.usageStatus = 'error'
            console.error('fail get UsageStatusData!', e)
          })

        // 지난 기간 데이터
        this.dataStatus.prevUsageStatus = 'load'
        const diff = moment(endDate).diff(moment(startDate), 'days') + 1
        let prevStartDate = moment(startDate).subtract(diff, 'days').format('YYYY-MM-DD')
        let prevEndDate = moment(endDate).subtract(diff, 'days').format('YYYY-MM-DD')
        axios.get(`biz/dashboard/user/?start_date=${prevStartDate}&end_date=${prevEndDate}`)
          .then(response => {
            this.prevUsageStatusData = response.data
            this.dataStatus.prevUsageStatus = 'success'
          })
          .catch(e => {
            this.dataStatus.prevUsageStatus = 'error'
            console.error('fail get prevUsageStatusData!', e)
          })
      },
      getUsageStatusChartData () {
        const { startDate, endDate } = this.dateRange

        this.dataStatus.usageStatusChart = 'load'
        axios.get(`biz/dashboard/user/graph/?start_date=${startDate}&end_date=${endDate}`)
          .then(response => {
            this.usageStatusChartData = response.data
            this.dataStatus.usageStatusChart = 'success'
          })
          .catch(e => {
            this.dataStatus.usageStatusChart = 'error'
            console.error('fail get Usage Status Chart Data!', e)
          })
      },
      getInflowPathChartData () {
        const { startDate, endDate } = this.dateRange

        this.dataStatus.inflowPathChart = 'load'
        axios.get(`biz/dashboard/source/?start_date=${startDate}&end_date=${endDate}`)
          .then(response => {
            this.inflowPathChartData = response.data
            this.dataStatus.inflowPathChart = 'success'
          })
          .catch(e => {
            console.error('fail get Inflow Path Data!', e)
            this.dataStatus.inflowPathChart = 'error'
          })
      },
      getApplicationStatusChartData () {
        const { startDate, endDate } = this.dateRange

        this.dataStatus.applicationStatusChart = 'load'
        axios.get(`biz/dashboard/application/graph/?start_date=${startDate}&end_date=${endDate}`)
          .then(response => {
            this.applicationStatusChartData = response.data.result
            this.dataStatus.applicationStatusChart = 'success'
          })
          .catch(e => {
            console.error('fail get Inflow Path Data!', e)
            this.dataStatus.applicationStatusChart = 'error'
          })
      },
      getApplicationStatusTableData () {
        const { startDate, endDate } = this.dateRange

        this.dataStatus.applicationStatusTable = 'load'
        axios.get(`biz/dashboard/application/?start_date=${startDate}&end_date=${endDate}`)
          .then(response => {
            this.applicationStatusTableData = response.data.result
            this.dataStatus.applicationStatusTable = 'success'
          })
          .catch(e => {
            console.error('fail get Inflow Path Data!', e)
            this.dataStatus.applicationStatusTable = 'error'
          })
      },
      getReportUsageData () {
        const { startDate, endDate } = this.dateRange

        this.dataStatus.reportUsageTable = 'load'
        axios.get(`biz/dashboard/report/?start_date=${startDate}&end_date=${endDate}`)
          .then(response => {
            this.reportUsageTableData = response.data.result
            this.dataStatus.reportUsageTable = 'success'
          })
          .catch(e => {
            this.dataStatus.reportUsageTable = 'error'
            console.error('fail get Report Usage Data!', e)
          })
      },
      scrollToReportTable () {
        const position = $('.card-report-table').offset().top - 64
        $('html,body').stop().animate({scrollTop: (position)}, 500)
      },
      toPartner () {
        this.$router.push({name: 'partner'})
      },
      toAdminHaezoom (locationData = {}, event) {
        const { startDate, endDate } = this.dateRange
        const eventTarget = event.target
        const baseUrl = `${location.protocol}//${location.hostname.replace('biz', 'admin')}`
        const targetUrl = baseUrl + locationData.path
        const query = locationData.query
        let qs = ''
        let status, step

        if (!_.isEmpty(query)) {
          qs += `/?start_date=${startDate}&end_date=${endDate}`

          if (query.hasOwnProperty('category')) {
            qs += `&category=${query.category}`
          }

          status = eventTarget.getAttribute('data-status')
          if (query.hasOwnProperty('status') && status) {
            qs += `&status=${status}`
          }

          step = eventTarget.getAttribute('data-step')
          if (query.hasOwnProperty('step') && step) {
            qs += `&step=${step}`
          }
        }

        window.open(targetUrl + qs)
      },
      toGoogleAnalytics () {
        window.open('https://analytics.google.com/')
      },
      // 대시보드 이용자 현황, 이전 기간과 비교 수치 구하는 함수
      getUsageStatusDiffString (prevCount, currentCount) {
        let prefix = '+'
        let postfix = '▲'
        if (currentCount < prevCount) {
          prefix = '-'
          postfix = '▼'
        }

        const diff = Math.abs(currentCount - prevCount)
        const percent = prevCount > 0 ? (diff / prevCount * 100).toFixed(2) : '-'

        return `${prefix}${diff} ( ${percent}% ${postfix} )`
      }
    },
    created () {
      const endDate = moment().format('YYYY-MM-DD')

      // 최근 일주일로 초기 기간값을 설정한다.
      this.dateRange = {
        startDate: moment().add(-6, 'd').format('YYYY-MM-DD'),
        endDate: endDate
      }

      // 캘린더 선택 가능 범위
      this.dateRangeOptions.minDate = moment('2018-12-31').format('YYYY-MM-DD')
      this.dateRangeOptions.maxDate = endDate

      // 데이터 요청
      this.search()
    }
  }
</script>

<style lang="scss">
  @import '~@/assets/css/components/chart';
  @import '~@/assets/css/components/daterange_picker';
</style>

<style lang="scss" scoped>
  [class*="col-"] {
    padding-left: 8px;
    padding-right: 8px;
  }

  h1, h4, p {
    margin: 0;
  }

  h1 {
    font-size: 32px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -1.3px;
    color: $font-color;
  }

  h4 {
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: -0.8px;
    color: $font-color;
  }

  #top {
    padding: 64px 0 0;

    h4 small {
      margin-left: 8px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: -0.8px;
      color: $font-color;
    }

    .container>.row {
      margin: 0 0 40px;
    }

    .toolbar {
      text-align: right;

      label {
        font-size: 20px;
        line-height: 1.4;
        letter-spacing: -0.8px;
        color: $font-color;
      }

      button {
        width: 81px;
        box-shadow: 0 1px 1px 0 rgba(173, 181, 189, 0.3);
      }

      .date-range-picker-wrap {
        display: inline-block;
        width: 308px;
        padding: 0 16px;
      }

      @media (max-width: $screen-xs-max) {
        margin: 24px 0 0;

        label {
          width: 100%;
          margin: 0 0 8px;
          font-size: 16px;
          text-align: left;
        }

        button {
          width: 100%;
          margin-top: 8px;
        }

        .date-range-picker-wrap {
          width: 100%;
          padding: 0;
        }
      }
    }

    .card {
      height: 84px;
      margin: 0 0 8px;
      padding: 16px 20px;
      border-radius: 16px;
      box-shadow: 0 2px 7px 0 rgba(136, 155, 194, 0.15);
      background-color: $hzc-white;
      cursor: pointer;

      >.row {
        margin: 0;
      }

      .col-xs-5 {
        padding: 10px 0 0 12px;
      }

      .col-xs-7 {
        padding: 0 32px 0 0;
        text-align: right;
      }

      .type {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: -0.35px;
        color: $hzc-gray-05;
      }

      .count {
        display: inline-block;
        font-size: 32px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: -1.3px;
        color: $font-color;

        small {
          font-size: 20px;
          font-weight: normal;
          line-height: 1.4;
          letter-spacing: -0.8px;
        }

        &.diff {
          white-space: nowrap;
          display: block;
          color: red;
          font-weight: normal;
          font-size: 14px;

          &.color-red {
            color: #FD7879;
          }

          &.color-blue {
            color: #4566C5;
          }
        }
      }

      .ic-arrow-right {
        position: absolute;
        top: 14px;
        right: 0;
        width: 12px;
        height: 12px;
        -webkit-mask: url('~@/assets/svg/ic-arrow-right-white.svg') no-repeat 50% 50%;
        mask: url('~@/assets/svg/ic-arrow-right-white.svg') no-repeat 50% 50%;
        -webkit-mask-size: cover;
        mask-size: cover;
        background-color: $blue-grey;
      }
    }
  }

  #content {
    padding: 0 0 64px;
    background-color: #fcfcfc;

    .card {
      margin: 12px 0;
      padding: 24px;
      border-radius: 16px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: $hzc-white;

      &-header {
        margin: 0 0 32px;

        .btn-csv-download {
          margin: 0 0 3px 5px;
          font-size: 10px;
          vertical-align: bottom;
        }
      }

      &-body {
        width: 100%;
      }

      .error-txt {
        font-size: 14px;
        font-weight: bold;
        color: $blue-grey;
        text-align: center;
        line-height: 320px;
      }

      .bar-loader {
        position: absolute;
        top: 50%;
        left: calc(50% - 30px);
        width: 60px;
        height: 60px;
      }
    }

    .card-usage-status,
    .card-inflow-path {
      height: 431px;

      .card-body {
        width: 100%;
        height: 320px;
      }
    }

    .card-usage-status {
      .radio-btn-group {
        height: 32px;
        padding: 6px;
        border-radius: 4px;
        background-color: $grey;

        label {
          width: 58px;
          margin: 0;
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: -0.35px;
          color: $hzc-gray-05;
        }

        .radio-btn-group-item {
          width: 58px;
          height: 24px;
          line-height: 24px;
        }

        .radio-btn-group-item input:hover + label,
        .radio-btn-group-item input:checked + label {
          color: $font-color;
          background-color: $hzc-white;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.14);
        }
      }

      @media (max-width: $screen-xs-max) {
        height: 472px;
        .radio-btn-group {
          margin: 8px 0 0;
        }
      }
    }

    .card-application-status,
    .card-application-table {
      height: 310px;
      margin: 12px 0;
    }

    .card-application-table,
    .card-report-table {
      table {
        width: 100%;

        tbody tr:first-child td {
          padding-top: 12px;
        }

        th, td {
          padding: 4px 0;
          font-size: 14px;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: -0.35px;

          &:not(:first-child) {
            text-align: center;
          }
        }

        th {
          font-weight: bold;
          color: $hzc-gray-05;
          border-bottom: 1px solid $hzc-gray-02;
        }

        td {
          font-weight: normal;
          color: $font-color;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .card-application-table {
      border: 0;
      box-shadow: none;
      background-color: #fcfcfc;

      .circle {
        width: 13px;
        height: 10px;
        margin: 5px 6px 0 0;
        border-radius: 5px;
        float: left;
      }
    }

    .card-report-table {
      height: 431px;
      margin: 12px 0 32px;

      thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
      }

      tbody {
        display: block;
        height: auto;
        max-height: 311px;
        overflow: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/Dashboard.vue